import { HtmlWidgetKey, HtmlWidgetSchema } from '@inference.engine/widgets/web';
import {
  makeCreateWidgetAction,
  type MakeCreateWidgetActionDeps,
  type WidgetActionProcessor,
} from '@/entities/widget';

/**
 * Opens a panel widget in the side panel. An inline widget renders inside its reply instead, so
 * it leaves the panel alone.
 */
export const makeProcessors = (deps: MakeCreateWidgetActionDeps): WidgetActionProcessor[] => {
  const openInPanel = makeCreateWidgetAction(deps);
  return [
    {
      key: HtmlWidgetKey,
      processor: (set) => {
        const open = openInPanel(set);
        return (messageId, widget) => {
          const parsed = HtmlWidgetSchema.safeParse(widget.data);
          if (parsed.success && parsed.data.placement === 'panel') open(messageId, widget);
        };
      },
    },
  ];
};
